export enum BvAmount {
  One = 'One',
  Two = 'Two',
  MoreThanTwo = 'MoreThanTwo'
}
